module.exports = __webpack_public_path__ + "img/eyes_female_asian_round_mask.5bd6416a.png";